import { Helmet } from "react-helmet-async";

const SITE = "https://playworld-shop.emergent.host";

export default function Seo({ title, description, path = "", image, type = "website" }) {
  const fullTitle = title
    ? `${title} · Anthony's Playworld`
    : "Anthony's Playworld Merch Store";
  const desc =
    description ||
    "Official merch store for Anthony's Playworld YouTube channel — bright, playful t-shirts, hoodies, hats, mugs, stickers, plushies and posters for kids and fans.";
  const canonical = `${SITE}${path || "/"}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
